findChildRefIds